export default __webpack_public_path__ + "static/media/demo-9.d1dc2928.png";